/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listCustomerSwaps} from '../api'

export const useMutationListCustomerSwaps = createReactQueryMutationHook('listCustomerSwaps', listCustomerSwaps)
